import React from 'react';
import {IProps} from './types';
import * as S from './styles';

const KeyboardShortcuts:React.FC<IProps> = (props) => {

  return (
    <S.Root>
      {props.children}
      <S.Box>
        <S.Text><S.Bold>Left Click</S.Bold> - Select/unselect multiple elements</S.Text>
        <S.Text><S.Bold>Right Click</S.Bold> - Add selected elements to a component</S.Text>
        <S.Text><S.Bold>Command,</S.Bold> + - Zoom in</S.Text>
        <S.Text><S.Bold>Command,</S.Bold> - - Zoom out</S.Text>
      </S.Box>
    </S.Root>
  );
}

export default KeyboardShortcuts;